/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Top Nav Search Icon component.
 */
export const TopNavSearchIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='TopNavSearchIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M10.24 15.7c3.447 0 6.241-2.843 6.241-6.35 0-3.507-2.794-6.35-6.24-6.35C6.794 3 4 5.843 4 9.35c0 3.507 2.794 6.35 6.24 6.35zM14.737 14.504L20.102 20'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap='round' />
      </svg>
    )} />
  );
};

export default TopNavSearchIcon;
